module.exports = __webpack_public_path__ + "resources/img/img_word_suggestion_en.0fa1823940fa14c318bfa98bde5e5723.png";